import React from 'react';
import { Card, CardContent, CardHeader } from '../ui/card';

export const KpiCard = ({ title, value, icon: Icon, subtitle, testId, trend }) => {
  return (
    <Card className="hover:shadow-[0_10px_24px_rgba(15,23,42,0.10)] transition-shadow duration-200" data-testid={testId}>
      <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
        <p className="text-sm font-medium text-muted-foreground">{title}</p>
        {Icon && (
          <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-accent">
            <Icon className="w-[18px] h-[18px] text-accent-foreground" />
          </div>
        )}
      </CardHeader>
      <CardContent>
        <div className="text-2xl md:text-3xl font-bold tabular-nums" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          {typeof value === 'number' ? value.toLocaleString('es-ES') : value}
        </div>
        {subtitle && (
          <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>
        )}
        {trend !== undefined && (
          <p className={`text-xs mt-1 font-medium ${trend >= 0 ? 'text-green-600' : 'text-red-600'}`}>
            {trend >= 0 ? '+' : ''}{trend}% vs. ayer
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default KpiCard;
